module.exports = __webpack_public_path__ + "static/media/brain.36f61436.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/brain.svg
// module id = 261
// module chunks = 3